// Basic
import PropTypes from 'prop-types';
// Lib
import { cn } from '@/common-utils/libraries/tailwind/utils';
// Components
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import Entity from '@/common-utils/components/renders/entity/Entity';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Spinner from '@/common-utils/components/renders/spinner/Spinner';
import { Modal, ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
// Lang
import { nsSession } from '@/app/i18n/namespaces';

/**
 * @param {boolean} isOpen
 * @param {function} setIsOpen
 * @param {object} mfaDeactivationConfirmation
 * @param {boolean} mfaDeactivationResponse
 *@returns {JSX} ModalDeactivationMfaConfirmation
 */
function ModalDeactivationMfaConfirmation({ isOpen, setIsOpen, mfaDeactivationResponse }) {
    const { isLoading, responseEntity } = mfaDeactivationResponse;
    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className={cn('max-w-xl', 'modal-secure-access')}>
                <HeaderTitle namespace={nsSession} title='mfa.deactivation_title' />
                <ModalBody >
                    {responseEntity && <Entity namespace={nsSession} entity={responseEntity} />}
                    {isLoading && <Spinner className='panel-spinner' />}
                </ModalBody>
                <FooterForm showSubmitButton={false} />
            </ModalContent>
        </Modal>
    );
}

ModalDeactivationMfaConfirmation.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    mfaDeactivationResponse: PropTypes.shape({
        isLoading: PropTypes.bool,
        responseEntity: PropTypes.string
    })
};

export default ModalDeactivationMfaConfirmation;